const baseEvent = {
  eventCategory: 'Optimizely FX',
  customMetrics: {},
  customVariables: {},
  _clear: true
}

export default {
  onOptimizelyDecision: ({ flagKey, ruleKey, variationKey, contentId }) => ({
    ...baseEvent,
    'event': 'optimizely-decision',
    'optimizely-flagKey': flagKey,
    'optimizely-ruleKey': ruleKey,
    'optimizely-variationKey': variationKey,
    ...(contentId && { 'optimizely-contentId': contentId }),
  }),
}
